import { createAction } from '@reduxjs/toolkit';

export const authKey = 'auth';

export interface AuthState {
    readonly isLoggedIn: boolean;
    readonly userName: string;
}

export enum AuthActionTypes {
    isLoggedInSet = 'auth/isLoggedInSet',
    userNameLoad = 'auth/userNameLoad',
    userNameSet = 'auth/userNameSet',
}

export const isLoggedInSet = createAction<boolean>(AuthActionTypes.isLoggedInSet);
export const userNameSet = createAction<string>(AuthActionTypes.userNameSet);
export const userNameLoad = createAction<string>(AuthActionTypes.userNameLoad);

export type AuthActions = ReturnType<typeof isLoggedInSet> | ReturnType<typeof userNameSet>;
